import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMagicEdit: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="magic-edit, magic-writing"><path d="M16.125 3.75L20.25 7.875L7.875 20.25H3.75V16.125L16.125 3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M5 5L4 7L2 8L4 9L5 11L6 9L8 8L6 7L5 5Z" fill="currentColor"/><path d="M9 2L8.33333 3.33333L7 4L8.33333 4.66667L9 6L9.66667 4.66667L11 4L9.66667 3.33333L9 2Z" fill="currentColor"/><path d="M18.5 15L17.6667 16.6667L16 17.5L17.6667 18.3333L18.5 20L19.3333 18.3333L21 17.5L19.3333 16.6667L18.5 15Z" fill="currentColor"/></CentralIconBase>;
};

export default IconMagicEdit;
